import React from "react";

import "./Dialog.component.scss";

export const Dialog = ({
    open = false,
    onClose = null,
    onConfirm = null,
    addedClassName = null,
    confirmLabel = null,
    cancelLabel = null,
    validSubmit = true,
    hideCancel = false,
    invertedButtons = false,
    children
}: {
    open?: boolean;
    onClose?: (...args: any[]) => any;
    onConfirm?: (...args: any[]) => any;
    addedClassName?: string | null;
    confirmLabel?: string | null;
    cancelLabel?: string | null;
    validSubmit?: boolean;
    hideCancel?: boolean;
    invertedButtons?: boolean;
    children: any;
}) => {
    return (
        <div
            className={addedClassName ? `${addedClassName} dialog` : "dialog"}
            style={{
                pointerEvents: open ? "auto" : "none",
                opacity: open ? 1 : 0
            }}
        >
            <div className="dialog-content">
                <div className="dialog-children">{children}</div>

                <div
                    className={`dialog-buttons ${
                        invertedButtons ? "inverted" : ""
                    }`}
                >
                    {!hideCancel && (
                        <button className="red-btn-negative" onClick={onClose}>
                            {cancelLabel ? cancelLabel : "Cancel"}
                        </button>
                    )}
                    <button
                        className="red-btn"
                        disabled={!validSubmit}
                        onClick={onConfirm}
                    >
                        {confirmLabel ? confirmLabel : "Confirm"}
                    </button>
                </div>
            </div>
        </div>
    );
};
